import { Component, OnInit } from '@angular/core';
import { RequisicaoBasica } from '../../../types/RequisicaoBasica.type';
import { RequisicaoAprovacao } from '../../../types/RequisicaoAprovacao.type';
import { UsuarioContexto } from '../../../types/UsuarioContexto.type';
import { WorkflowService } from '../workflow.service';
import { ToastService } from '../../../services/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-requisicao-detalhada',
  templateUrl: './requisicao-detalhada.component.html',
  styleUrl: './requisicao-detalhada.component.css',
  providers: [ConfirmationService]
})
export class RequisicaoDetalhadaComponent implements OnInit{

  carregando: boolean = true;
  requisicao: RequisicaoBasica | null = null;
  itemSelecionado: any = null;
  exibirDialogItem: boolean = false;
  mostrarDetalhes: boolean = false;
  comentarios: string = '';
  loadingAprovacao: boolean = false;

  loadingExportacao: boolean = false;

  // Contexto do usuário
  usuarioContexto: UsuarioContexto | null = null;

  constructor(
    private workflowService: WorkflowService,
    private toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService
  ) {
    this.buscaRequisicao();
  }

  isAprovador(): boolean {

    return this.usuarioContexto?.workflows.includes(this.requisicao?.workflow || '') || false;

    // return this.usuarioContexto?.aprovador || false;
  }

  ngOnInit() {
    this.carregarContextoUsuario();
  }

  carregarContextoUsuario() {
    this.workflowService.getUsuarioContexto().subscribe({
      next: (contexto) => {
        this.usuarioContexto = contexto;
      },
      error: (erro) => {
        console.error('Erro ao carregar contexto do usuário:', erro);
        this.usuarioContexto = { aprovador: false, workflows: [] };
      }
    });
  }

  buscaRequisicao() {

    let id = this.activatedRoute.snapshot.paramMap.get('id');

    this.workflowService.getRequisicao(id).subscribe({
      next: (data) => {

        this.requisicao = data;
        // Inicializa todos os itens como selecionados por padrão
        this.requisicao.itens?.forEach(item => item.selecionado = true);
        this.carregando = false;

      },
      error: (err) => {

        this.toastService.erro("Erro", err.error.message)

      },
      complete: () => {
        this.carregando = false;
      }
    })

  }

  visualizarDetalhesItem(item: any) {
    this.itemSelecionado = item;
    this.exibirDialogItem = true;
  }

  calcularValorTotal(): number {
    if (!this.requisicao || !this.requisicao.itens) {
      return 0;
    }

    return this.requisicao.itens.reduce((total, item) => {
      const valor = item.payloadNovo?.vlProvisao || 0;
      return total + valor;
    }, 0);
  }

  selecionarTodos(selecionar: boolean) {
    this.requisicao?.itens?.forEach(item => item.selecionado = selecionar);
  }

  contarItensSelecionados(): number {
    return this.requisicao?.itens?.filter(item => item.selecionado).length || 0;
  }

  getTextoBotaoPrincipal(): string {
    const selecionados = this.contarItensSelecionados();
    const total = this.requisicao?.quantidadeItens || 0;

    if (selecionados === 0 && total > 1) {
      return 'Rejeitar Todos';
    } else if (selecionados === 0 && total == 1) {
      return 'Rejeitar';
    } else if (selecionados === total && total == 1) {
      return 'Aprovar';
    }else if (selecionados === total) {
      return 'Aprovar Todos';
    } else {
      return `Aprovar Parcialmente (${selecionados} de ${total})`;
    }
  }

  getSeveridadeBotaoPrincipal(): 'success' | 'danger' | 'info' {
    const selecionados = this.contarItensSelecionados();
    const total = this.requisicao?.quantidadeItens || 0;

    if (selecionados === 0) {
      return 'danger';
    } else if (selecionados === total) {
      return 'success';
    } else {
      return 'info';
    }
  }

  getIconeBotaoPrincipal(): string {
    const selecionados = this.contarItensSelecionados();

    if (selecionados === 0) {
      return 'pi pi-times';
    } else {
      return 'pi pi-check';
    }
  }

  executarAcaoPrincipal() {
    const selecionados = this.contarItensSelecionados();
    const total = this.requisicao?.quantidadeItens || 0;

    if (selecionados === 0) {
      this.rejeitarTudo();
    } else if (selecionados === total) {
      this.aprovarTudo();
    } else {
      this.aprovarParcialmente();
    }
  }

  mostrarCampoComentarios(): boolean {
    const selecionados = this.contarItensSelecionados();
    const total = this.requisicao?.quantidadeItens || 0;

    // Mostra apenas quando for parcial ou rejeição total (não todos selecionados)
    return selecionados !== total;
  }

  getPayloadChaves(payload: any): string[] {
    if (!payload) return [];
    return Object.keys(payload);
  }

  formatarValorPayload(valor: any): string {
    // Se for null ou undefined
    if (valor === null || valor === undefined) {
      return '-';
    }

    // Se for array (provavelmente data: [ano, mes, dia])
    if (Array.isArray(valor)) {
      if (valor.length === 3 && typeof valor[0] === 'number') {
        // Formato de data [ano, mes, dia]
        const [ano, mes, dia] = valor;
        return `${String(dia).padStart(2, '0')}/${String(mes).padStart(2, '0')}/${ano}`;
      }
      return valor.join(', ');
    }

    // Se for número
    if (typeof valor === 'number') {
      // Se parecer um valor monetário (tem casas decimais)
      if (valor % 1 !== 0) {
        return `R$ ${valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      }
      return valor.toLocaleString('pt-BR');
    }

    // Se for boolean
    if (typeof valor === 'boolean') {
      return valor ? 'Sim' : 'Não';
    }

    // Se for string
    return String(valor);
  }

  formatarNomeChave(chave: string): string {
    // Converte nomes de campos técnicos em legíveis
    const mapeamento: { [key: string]: string } = {
      'idProv': 'ID Provisão',
      'cdUnidId': 'Código Unidade',
      'noDocErp': 'Nº Doc ERP',
      'instancia': 'Instância',
      'cdTpPropri': 'Código Tipo',
      'dtIntegErp': 'Data Integração ERP',
      'dtProvisao': 'Data Provisão',
      'dtRecebido': 'Data Recebido',
      'noLotePims': 'Nº Lote PIMS',
      'vlProvisao': 'Valor',
      'cdFilialErp': 'Filial ERP',
      'cdFornecErp': 'Fornecedor ERP',
      'dtIntegPims': 'Data Integração PIMS',
      'cdEmpresaErp': 'Empresa ERP',
      'cdFornecPims': 'Fornecedor PIMS',
      'cdFundoAgric': 'Fundo Agrícola',
      'fgStatusInteg': 'Status Integração',
      'noCtaContabil': 'Conta Contábil',
      'cdContratoPims': 'Código Contrato',
      'deHistContabil': 'Histórico Contábil'
    };

    return mapeamento[chave] || chave;
  }

  aprovarTudo() {
    const itensSelecionadosCount = this.contarItensSelecionados();

    if (itensSelecionadosCount === 0) {
      this.toastService.alerta('Atenção', 'Selecione pelo menos um item para aprovar');
      return;
    }

    this.confirmationService.confirm({
      header: "Aprovação",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      message: `Você realmente deseja aprovar a requisição #${this.requisicao?.identificador}?`,
      icon: 'pi pi-check-circle',
      acceptButtonStyleClass: 'p-button-success',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined',

      accept: () => {
        this.loadingAprovacao = true;

        const aprovacao: RequisicaoAprovacao = {
          idRequisicao: this.requisicao!.id,
          itensAprovados: ["ALL"],
          itensReprovados: [],
          justificativaReprova: ""
        };

        this.enviarAprovacao(aprovacao);
      }
    });
  }

  rejeitarTudo() {
    // Validação de comentários obrigatórios
    if (!this.comentarios || this.comentarios.trim().length === 0) {
      this.toastService.alerta('Atenção', 'Por favor, informe uma justificativa para a rejeição');
      return;
    }

    this.confirmationService.confirm({
      header: "Rejeição",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      message: `Você realmente deseja rejeitar todos os itens da requisição #${this.requisicao?.identificador}?`,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined',

      accept: () => {
        this.loadingAprovacao = true;

        const aprovacao: RequisicaoAprovacao = {
          idRequisicao: this.requisicao!.id,
          itensAprovados: [],
          itensReprovados: ["ALL"],
          justificativaReprova: this.comentarios
        };

        this.enviarAprovacao(aprovacao);
      }
    });
  }

  aprovarParcialmente() {
    const itensSelecionadosCount = this.contarItensSelecionados();
    const totalItens = this.requisicao?.quantidadeItens || 0;

    if (itensSelecionadosCount === 0) {
      this.toastService.alerta('Atenção', 'Selecione pelo menos um item para aprovação parcial');
      return;
    }

    if (itensSelecionadosCount === totalItens) {
      this.toastService.info('Informação', 'Todos os itens estão selecionados. Use "Aprovar Tudo" para aprovar todos.');
      return;
    }

    // Validação de comentários obrigatórios para aprovação parcial
    if (!this.comentarios || this.comentarios.trim().length === 0) {
      this.toastService.alerta('Atenção', 'Por favor, informe uma justificativa para a aprovação parcial');
      return;
    }

    this.confirmationService.confirm({
      header: "Aprovação Parcial",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      message: `Você realmente deseja aprovar parcialmente a requisição #${this.requisicao?.identificador}? (${itensSelecionadosCount} de ${totalItens} itens)`,
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-info',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined',

      accept: () => {
        this.loadingAprovacao = true;

        const itensAprovados = this.requisicao?.itens
          ?.filter(item => item.selecionado)
          .map(item => item.publicId) || [];

        const itensReprovados = this.requisicao?.itens
          ?.filter(item => !item.selecionado)
          .map(item => item.publicId) || [];

        const aprovacao: RequisicaoAprovacao = {
          idRequisicao: this.requisicao!.id,
          itensAprovados: itensAprovados,
          itensReprovados: itensReprovados,
          justificativaReprova: this.comentarios
        };

        this.enviarAprovacao(aprovacao);
      }
    });
  }

  cancelarRequisicao() {
    this.confirmationService.confirm({
      header: "Cancelar Requisição",
      acceptLabel: "Sim, cancelar",
      rejectLabel: "Não",
      message: `Você realmente deseja cancelar a requisição #${this.requisicao?.identificador}? Esta ação não pode ser desfeita.`,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined',

      accept: () => {
        this.loadingAprovacao = true;

        this.workflowService.cancelarRequisicao(this.requisicao!.id).subscribe({
          next: (data) => {
            this.toastService.sucesso("Sucesso", "Requisição cancelada com sucesso");
            this.buscaRequisicao();
          },
          error: (error) => {
            console.log(error)
            this.toastService.erro("Erro", error.error?.message || 'Erro ao cancelar requisição');
            this.loadingAprovacao = false;
          },
          complete: () => {
            this.loadingAprovacao = false;
          }
        });
      }
    });
  }

  private enviarAprovacao(aprovacao: RequisicaoAprovacao) {
    this.workflowService.postAprovar(aprovacao).subscribe({
      next: (data) => {
        this.toastService.sucesso("Sucesso", data.mensagem);

        this.comentarios = "";

        // Redirecionar de volta para a listagem de requisições
        setTimeout(() => {
          this.router.navigate(['/workflow']);
        }, 1500);
      },
      error: (error) => {
        this.toastService.erro("Erro", error.error?.message || 'Erro ao processar aprovação');
        this.loadingAprovacao = false;
      },
      complete: () => {
        this.loadingAprovacao = false;
      }
    });
  }

  exportar() {

  this.loadingExportacao = true;

    this.workflowService
        .postExportRequisicao(
          this.requisicao?.id
        )
        .subscribe({
          next: (value) => {
            const url = window.URL.createObjectURL(value);
            const a = document.createElement('a')
            a.href = url
            a.download = 'requisicao.xlsx'
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          },
          error: (error) => {
            this.toastService.erro("Exportar", 'Erro ao exportar:' + error.error.message);
            this.loadingExportacao = false;
          },
          complete: () => {
            this.loadingExportacao = false;
          },

        });
  }

}
